import { Action } from '@ngrx/store';
import { RuleModel } from '../../models/RuleModel';

export const GET_COMPARISON_DATE_SUCCESS = '[Rule] Get Comparison Date Successfully';

export class GetComparisonDateSuccessAction implements Action {
  readonly type = GET_COMPARISON_DATE_SUCCESS;

  constructor(public payload: { model: string[] }) {}
}



// WEBPACK FOOTER //
// ./src/app/businessRule/store/actions/GetComparisonDateSuccessAction.ts